export const staticStrings = {
  cardNumber: 'Card Number',
  web: 'web',
  somethingwentWrong: 'Something went wrong!',
  areyouSureWantToCancel: 'Are your sure to cancel\n your payment ?',
  cancelTransaction: 'Cancel Transaction',
  ok: 'Yes',
  yesCancel: 'Cancel payment',
  Cancel: 'Proceed to payment',
  saveThisCard: 'Save this card for faster transactions',
  cvvHover:
    'The CVV number is the last three digits at the back of your card. For American Express cards, the CVV is a 4-digit number on the front of the card.',
  poweredBy: 'Powered by',
  jioMoney: 'JioMoney',
  jioPay: 'JioPay Business',
  iwantTosignUp: 'Yes, I want to sign-up for JioMoney wallet',
  passwordConfirm: 'Password and Confirm Password should be same',
  validMobile: 'Please enter a valide 10 digit mobile number',
  pleaseEnterMobile: 'Please enter your mobile number to login',
  byProceeding: 'By proceeding, you agree to our',
  termsCons: ' Terms & Conditions',
  NotValidCard: 'Please enter a valid card number',
  cardNotAllowed: 'Sorry, this card is not supported for payment',
  enterPWDText: 'Enter the password set for',
  setPWDText: "It seems you don't set a password for this account. To proceed, Please set a password for",
  forgotPWD: 'Forgot Password',
  createPWD: 'Create Password',
  simpleSteps: 'Simple Steps to Pay through UPI',
  vpa: `Enter your Virtual Payment Address (VPA),
click on 'Pay' button, you will be re-directed to a loader/waiting page`,
  upiins: 'In the mean time, To complete your UPI payment follow below steps:',
  psp: 'Login into your PSP (Payment Service Provider APP) application.',
  authorise: 'Authorise payment.',
  offerError: 'Offer not applicable on the selected card',
  invalidOffer: 'Offer not applicable on the selected',
  offerErrorUpi: 'Offer not applicable on the entered VPA',
  offerApplied: 'Offer Applied',
  sodexoHeader: 'Pluxee | Sodexo Meal Pass',
  sodexoPayUsing: 'Pay using Pluxee | Sodexo Meal Pass',
  regenerateQR: 'Regenerate QR',
  selectAnyUpiApp: 'Use any UPI app on your phone to scan this QR code',
  qRCodeExpired: 'QR code Expired',
  qRCodeExpiresIn: 'QR code Expires in',
}

export const errorMessage = {
  defautCatchMessage: 'Oops! something went wrong',
  invalidVPA: 'Invalid VPA. Please enter valid VPA',
  invalidUpiNumber: 'Invalid UPI number. Please enter valid UPI Number',
  invalidCard: 'Invalid card details',
  invalidOTP: 'OTP is incorrect',
  generatePassword: 'Failed generate Password',
  offerNotApplicable: 'Offer not applicable on the selected card',
}

export const rupayCardMatrix = [
  { start: '5085000000', end: '5089999999' }, // (508[5-9][0-9]{12})
  { start: '6069850000', end: '6079849999' }, // (6069[8-9][0-9]{11})|(607[0-8][0-9]{12})|(6079[0-8][0-9]{11})
  { start: '6080010000', end: '6082009999' }, // (608[0-5][0-9]{12})
  { start: '6082010000', end: '6083009999' }, // covered in prev
  { start: '6083010000', end: '6083509999' }, // covered in prev
  { start: '6083510000', end: '6085009999' }, // covered in prev
  { start: '6521500000', end: '6528499999' },
  // (6521[5-9][0-9]{11})|(652[2-9][0-9]{12})|(6530[0-9]{12})|(6531[0-4][0-9]{11})
  { start: '6528500000', end: '6530499999' }, // covered in prev
  { start: '6530500000', end: '6531499999' }, // covered in prev
  { start: '3528000000', end: '3589999999' }, // covered in prev
  { start: '3000000000', end: '3059999999' },
  // (30[0-5][0-9]{13}) | (3095[0-9]{12}) | (36[0-9]{14}) | (3[8-9][0-9]{14})
  { start: '3095000000', end: '3095999999' }, // covered in prev
  { start: '3600000000', end: '3699999999' }, // covered in prev
  { start: '3800000000', end: '3999999999' }, // covered in prev
  { start: '6011000000', end: '6011039999' },
  // (60110[0-3][0-9]{10}) | (60110[5-9][0-9]{10}) |(6011[2-4][0-9]{11})
  // |(601174[0-9]{10}) | (60117[7-9][0-9]{10}) | (6011[8-9][6-9][0-9]{10})
  { start: '6011050000', end: '6011099999' }, // covered in prev
  { start: '6011200000', end: '6011499999' }, // covered in prev
  { start: '6011740000', end: '6011749999' }, // covered in prev
  { start: '6011770000', end: '6011799999' }, // covered in prev
  { start: '6011860000', end: '6011999999' }, // covered in prev
  { start: '6440000000', end: '6521499999' },
  // ((64[4-8][0-9]{2}|649[0-8][0-9]|6499[0-9]|65[01][0-9]{2}|6520[0-9]|6521[0-4]))([0-9]{11})
  { start: '6531500000', end: '6599999999' }, // ((6531[5-9]|653[2-9][0-9]|65[4-9][0-9]{2}))([0-9]{11})
  { start: '8172000000', end: '8198999999' }, // ((817[2-9]|818[0-9]|819[0-8]))([0-9]{12})
  { start: '8199000000', end: '8201999999' },
  // { start: '6522676935', end: '6935573491' },
]

export const cardVendorPrefixes = {
  maestro: [
    '502260',
    '504433',
    '504434',
    '504435',
    '504437',
    '504645',
    '504681',
    '504753',
    '504775',
    '504809',
    '504817',
    '504834',
    '504848',
    '504884',
    '504973',
    '504993',
    '508125',
    '508126',
    '508159',
    '508192',
    '508227',
    '56',
    '57',
    '58',
    '600206',
    '603123',
    '603741',
    '603845',
    '622018',
    '67',
    '502045',
    '503898',
    '603',
  ],
  discover: ['8', '6011', '65', '644', '645', '646', '647', '648', '649'],
  diners: ['300', '301', '302', '304', '305', '309', '36', '38', '39'],
  masterCard: ['5', '22', '23', '24', '25', '26', '27'],
  amex: ['34', '37'],
  visa: ['4'],
  none: ['0'],
}

export const testIds = {
  titleSubtitleID: 'titleSubtitleID',
  dismissId: 'dismissId',
  cancelBtnID: 'cancelBtnID',
  okBtnID: 'okBtnID',
  dropDownListViewID: 'dropDownListViewID',
  dropdownTouchableID: 'dropdownTouchableID',
  DropDownPlaceHolderID: 'DropDownPlaceHolderID',
  emptyView: 'emptyView',
  modelDialog: 'modelDialog',
  cvvTextInput: 'cvvTextInput',
  expiryDateTextInput: 'expiryDateTextInput',
  mobileNumber: 'mobileNumber',
  proceedBtn: 'proceedBtn',
  arcViewTest: 'arcViewTest',
}
